export default "__VITE_ASSET__DY1P4XOv__"